import { FC } from "react";
import { NativeProps } from "@/utils/components-utils";
import { useTranslation } from "next-i18next";

export type SelectedItem = {
  label: string;
  value: string;
};
type Props = {
  onSelected: (value: SelectedItem) => void;
  list: SelectedItem[];
} & NativeProps;

export const SelectView: FC<Props> = ({ onSelected, list, className }) => {
  const { t } = useTranslation("common");
  return (
    <ul className={className}>
      {list.map((item, index) => {
        return (
          <li
            key={index}
            onClick={(e) => {
              onSelected(item);
            }}
          >
            {item.label}
          </li>
        );
      })}

      {list.length === 0 && (
        <p
          style={{ color: "var(--rf-label-text-color)" }}
          className="mt-4 text-center text-sm"
        >
          {t("nothing-here")}
        </p>
      )}
    </ul>
  );
};
